import _ from 'lodash';

export default class DataUtils {

    static includesArrayValue(arrayA, arrayB) {
        return arrayA.some(value => arrayB.includes(value));
    }

    static indexRows(data, isSelected ) {
        const mappedRowIndices = [];
        const rows =  !data
            ? []
            : Object.keys(data).reduce((acc, key, index) => {
                const item = data[key];
                item.key = key;
                mappedRowIndices.push(key);
                item.isSelected = isSelected(index);
                acc.push(item);
                return acc;
            }, []);
        return {rows, mappedRowIndices};
    }

    static normalizeField(type) {
        return (value, previousValue, allValues) => {
            if (type === 'number' && !isNaN(value)) {
                return Number(value);
            } else {
                return value;
            }
        };
    }

    static sortByKey(array, key, direction) {
        return array.sort((a, b) => {
            const x = a[key], y = b[key];
            if (direction && direction.match(/asc/i)) return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            else return ((x > y) ? -1 : ((x < y) ? 1 : 0));
        });
    }

    static trimField(event) {
        if (typeof event.target.value === 'string') {
            event.target.value = event.target.value.trim();
        }
        return event;
    }


    // Firebase transactions

    static firebaseTxHandleError(error, committed) {
        if (error) {
            return error;
        } else if (!committed) {
            return 'Failed to commit.';
        }
    }

    static firebaseTxAddToList(list, key) {
        list.push(key);
        return list;
    }

    static firebaseTxUpdatePropertyOfObject(object, keys, propertyKey, value) {
        keys.forEach(key => _.set(object, `${key}.${propertyKey}`, value));
        return object;
    }

    static firebaseTxRemoveFromList(list, key) {
        if (list.includes) {
            list = list.filter(item => item !== key);
        }
        return list;
    }

    static firebaseTxRemoveFromObject(object, keys) {
        keys.forEach(key => _.unset(object, key));
        return object;
    }

    static firebaseTxUpdateOrder(data, newKey, oldKey) {
        const newOrderValue = data[newKey].order;
        const oldOrderValue = data[oldKey].order;
        const isIncreasing = newOrderValue > oldOrderValue;
        Object.keys(data).filter(itemKey => !data[itemKey].isArchived).forEach(iterKey => {
            if (iterKey === oldKey) {
                data[iterKey].order = newOrderValue;
            } else if (isIncreasing && oldOrderValue < data[iterKey].order && data[iterKey].order <= newOrderValue) {
                data[iterKey].order -= 1;
            } else if (!isIncreasing && oldOrderValue > data[iterKey].order && data[iterKey].order >= newOrderValue) {
                data[iterKey].order += 1;
            }
        });

        return data;
    }


    // Videos

    static filterArchivedVideos(videos) {
        if (videos) {
            return Object.keys(videos).reduce((acc, key) => {
                const video = videos[key];
                if (video.url && !video.isArchived) acc.push(videos[key]);
                return acc;
            }, []);
        } else {
            return [];
        }
    }

}


// WEBPACK FOOTER //
// ./src/util/DataUtils.js